import { TFunction } from '#hooks/useI18n';
import * as yup from 'yup';
import { SchemaOf } from 'yup';

import { FormValidation } from '@zazume/zzm-base';

import { toFormValidation } from '#/utils/formValidation/toFormValidation';

export interface EditSignerModalFormData {
  email: string;
}

const schema = (t: TFunction): SchemaOf<EditSignerModalFormData> => {
  return yup.object().shape({
    email: yup.string().email(t('general.forms.invalid')).required(t('general.forms.mandatory'))
  });
};

export const getEditSignerSchema = (t: TFunction): FormValidation => toFormValidation(t, schema(t));
